(function () {
  var root = document.querySelector('[data-varenzo-pdp]');
  if (!root) return;

  var dataEl = document.querySelector('[data-varenzo-product-data]');
  var payload = {};
  if (dataEl) {
    try { payload = JSON.parse(dataEl.textContent || '{}'); } catch (e) { payload = {}; }
  }
  var productJson = payload.product || {};
  var variantPrices = payload.variantPrices || {};
  var statusEl = root.querySelector('[data-pdp-status]');

  function say(msg) {
    if (!statusEl) return;
    statusEl.textContent = '';
    setTimeout(function () { statusEl.textContent = msg; }, 60);
  }

  /* ---------- Details drawer (modal dialog) ---------- */
  var toggle = root.querySelector('[data-details-toggle]');
  var panel = root.querySelector('[data-details-panel]');
  var overlay = root.querySelector('[data-details-overlay]');
  var close = root.querySelector('[data-details-close]');

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function pageSiblings(on) {
    /* Make the rest of the page inert while the modal drawer is open. */
    var main = document.getElementById('MainContent');
    var header = document.getElementById('header-group');
    var footer = document.querySelector('.page-wrapper > footer');
    var shell = root.querySelector('.v-pdp-shell');
    [shell, header, footer].forEach(function (el) {
      if (!el) return;
      if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert');
    });
  }

  function openPanel() {
    panel.hidden = false;
    overlay.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    pageSiblings(true);
    requestAnimationFrame(function () {
      panel.classList.add('open');
      overlay.classList.add('open');
      close.focus();
    });
  }
  function shutPanel() {
    panel.classList.remove('open');
    overlay.classList.remove('open');
    document.documentElement.style.overflow = '';
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    pageSiblings(false);
    if (toggle) toggle.focus();
    setTimeout(function () {
      panel.hidden = true;
      overlay.hidden = true;
    }, 260);
  }
  if (toggle) toggle.addEventListener('click', openPanel);
  if (close) close.addEventListener('click', shutPanel);
  if (overlay) overlay.addEventListener('click', shutPanel);
  document.addEventListener('keydown', function (e) {
    if (!panel || panel.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); shutPanel(); return; }
    if (e.key === 'Tab') {
      var items = Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return el.offsetParent !== null && !el.closest('[inert]');
      });
      if (!items.length) { e.preventDefault(); return; }
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    }
  });

  /* Accordion: collapsed bodies are inert so hidden content is not focusable */
  function syncAccordion(item) {
    var body = item.querySelector('.v-accordion-body');
    if (!body) return;
    if (item.classList.contains('open')) body.removeAttribute('inert');
    else body.setAttribute('inert', '');
  }
  root.querySelectorAll('.v-accordion-item').forEach(syncAccordion);
  root.querySelectorAll('[data-accordion-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.v-accordion-item');
      var isOpen = item.classList.contains('open');
      item.classList.toggle('open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
      syncAccordion(item);
    });
  });

  /* ---------- Variant option buttons ---------- */
  var optionButtons = root.querySelectorAll('[data-option-index].v-option-btn');
  var variantInput = root.querySelector('[data-variant-id]');
  var priceEl = root.querySelector('[data-price]');
  var addBtn = root.querySelector('[data-add-to-cart]');
  var skuEl = root.querySelector('[data-sku-value]');

  if (optionButtons.length && productJson.variants) {
    var selected = (productJson.variants[0].options || []).slice();
    root.querySelectorAll('.v-option-btn.active').forEach(function (b) {
      var i = parseInt(b.getAttribute('data-option-index'), 10);
      selected[i] = b.getAttribute('data-value');
    });

    function findVariant(sel) {
      for (var i = 0; i < productJson.variants.length; i++) {
        var v = productJson.variants[i];
        var opts = v.options || [];
        var match = true;
        for (var j = 0; j < sel.length; j++) {
          if (opts[j] !== sel[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function updateUI(announce) {
      var variant = findVariant(selected);
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      var price = variantPrices[String(variant.id)] || (priceEl && priceEl.textContent);
      if (priceEl) priceEl.textContent = price;
      if (skuEl) skuEl.textContent = variant.sku || 'Assigned at fulfillment';
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      }
      if (announce) {
        say('Selected ' + selected.join(', ') + '. Price ' + price + '. ' + (variant.available ? 'Available.' : 'Sold out.'));
      }
    }

    function updateOptionAvailability() {
      optionButtons.forEach(function (btn) {
        var idx = parseInt(btn.getAttribute('data-option-index'), 10);
        var val = btn.getAttribute('data-value');
        var hypothetical = selected.slice();
        hypothetical[idx] = val;
        var v = findVariant(hypothetical);
        var isCurrentlyActive = btn.classList.contains('active');
        if (!v || (!v.available && !isCurrentlyActive)) {
          btn.disabled = true;
        } else {
          btn.disabled = false;
        }
      });
    }

    root.querySelectorAll('.v-option-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var idx = parseInt(btn.getAttribute('data-option-index'), 10);
        var val = btn.getAttribute('data-value');
        selected[idx] = val;
        var group = btn.closest('.v-option-group');
        group.querySelectorAll('.v-option-btn').forEach(function (b) {
          b.classList.remove('active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');
        updateUI(true);
        updateOptionAvailability();
      });
    });

    updateOptionAvailability();
  }
})();
